import { ActionControllerEventName, ParentEvent, ResourcesManager, ResourceType, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { SpectrophotometerScreen } from './SpectrophotometerScreen';
import { Box3, Euler, Mesh, MeshBasicMaterial, Object3D, Quaternion, Vector3 } from 'three';
import { SpectrophotometerMode } from './index';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { MaterialImprovement } from '../../../utils/MaterialImprovement';
export class Apparat extends ViewerModule {
    constructor() {
        super();
        this.currentMode = SpectrophotometerMode.absorbance;
        this.defaultCurrentMode = SpectrophotometerMode.absorbance;
        this.numericValues = {
            'wavelength': 400,
            'transmittance': -5,
            'absorbance': 0
        };
        this.enabledModes = {
            zeroAdjustKnob: false,
            transmittance: false,
            wavelength: false,
            mode: false
        };
        this.defaultNumericValues = {
            'wavelength': 400,
            'transmittance': -5,
            'absorbance': 0
        };
        this.defaultEnabledModes = {
            zeroAdjustKnob: false,
            transmittance: false,
            wavelength: false,
            mode: false
        };
        this.addObject(this.screen = new SpectrophotometerScreen());
        this.resourcesInUse.push({
            name: 'spectrophotometer_cap',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/spectrophotometer_cap.fbx')
        }, {
            name: 'test_tube_red',
            type: ResourceType.FBX_MODEL,
            priority: 0,
            url: require('../../../../assets/models/spectrophotometer/test_tube_red.fbx')
        });
    }
    init() {
        this.screen.init();
        this.addObject(this.model = ResourcesManager.getModel('spectrophotometer_apparat'));
        this.addObject(this.cap = ResourcesManager.getModel('spectrophotometer_cap'));
        MaterialImprovement.upgradeMaterialsFromModel(this.model, 'spectrophotometer_apparat');
        MaterialImprovement.upgradeMaterialsFromModel(this.cap, 'spectrophotometer_cap');
        this.cap.position.set(-0.4492040169697496, -0.22671571075107377, 0.42450415545325504);
        this.generateUI();
    }
    toggleCap(toggle) {
        this.fire('capChanged', new ParentEvent('', { openned: toggle }));
        let newPosition, newRotation;
        if (toggle) {
            newPosition = new Vector3(-0.4492040169697496, -0.22671571075107377, 0.42450415545325504);
            newRotation = new Quaternion().setFromEuler(new Euler(0, 0, 0));
        }
        else {
            newPosition = new Vector3(-0.4492040169697496, -0.22671571075107377, 0.42450415545325504);
            newRotation = new Quaternion().setFromEuler(new Euler(0.6066630100070186, 0, 0));
        }
        const oldRotation = this.cap.quaternion.clone(), oldPosition = this.cap.position.clone();
        new TWEEN.Tween(this.cap.position).to(newPosition, 1500)
            .easing(TWEEN.Easing.Quadratic.Out)
            .onUpdate((alpha) => {
            this.cap.quaternion.copy(oldRotation.clone().slerp(newRotation, alpha));
        })
            .onComplete(() => {
        })
            .start();
    }
    generateUI() {
        const positions = {
            zeroAdjustKnob: {
                type: 'knob',
                childName: 'knob2',
                positionLeft: new Vector3(0.03, -0.89, 1.16),
                positionRight: new Vector3(0.88, -0.89, 1.16),
                rotation: new Euler()
            },
            transmittance: {
                type: 'knob',
                childName: 'knob3',
                positionLeft: new Vector3(1.28, -0.89, 1.16),
                positionRight: new Vector3(2.11, -0.89, 1.16),
                rotation: new Euler()
            },
            wavelength: {
                type: 'knob',
                childName: 'knob1',
                positionLeft: new Vector3(-1.24, -0.89, 1.16),
                positionRight: new Vector3(-0.37, -0.89, 1.16),
                rotation: new Euler()
            },
            mode: {
                type: 'button',
                childName: 'mode',
                position: new Vector3(),
                rotation: new Euler()
            }
        };
        this.screen.uiObject.position.set(0.41, 0.37, 0);
        this.screen.uiObject.rotation.set(-0.311, 0.0, 0.0);
        this.screen.uiObject.scale.set(0.25, 0.25, 0.25);
        this.modeButton = this.model.getObjectByName(positions.mode.childName);
        this.actionController.on(ActionControllerEventName.click, this.modeButton, () => {
            this.onModeClick();
        });
        const wavelength = this.model.getObjectByName(positions.wavelength.childName);
        this.actionController.on(ActionControllerEventName.click, wavelength, () => this.onKnobClick('wavelength', positions.wavelength.positionLeft, positions.wavelength.positionRight, positions.wavelength.rotation));
        const zeroAdjustKnob = this.model.getObjectByName(positions.zeroAdjustKnob.childName);
        this.actionController.on(ActionControllerEventName.click, zeroAdjustKnob, () => this.onKnobClick('zeroAdjustKnob', positions.zeroAdjustKnob.positionLeft, positions.zeroAdjustKnob.positionRight, positions.zeroAdjustKnob.rotation));
        const transmittance = this.model.getObjectByName(positions.transmittance.childName);
        this.actionController.on(ActionControllerEventName.click, transmittance, () => this.onKnobClick('transmittance', positions.transmittance.positionLeft, positions.transmittance.positionRight, positions.transmittance.rotation));
    }
    onKnobClick(knobName, minusButtonPosition, plusButtonPosition, rotation) {
        if (!this.enabledModes[knobName])
            return;
        if (!this.minusButton) {
            this.addObject(this.minusButton = new IconButtonComponent({
                text: '',
                diameter: 0.3
            }));
            this.addObject(this.plusButton = new IconButtonComponent({
                text: '',
                diameter: 0.3
            }));
        }
        this.plusButton.off('click');
        this.minusButton.off('click');
        this.minusButton.uiObject.visible = true;
        this.plusButton.uiObject.visible = true;
        this.minusButton.uiObject.position.copy(minusButtonPosition);
        this.plusButton.uiObject.position.copy(plusButtonPosition);
        this.minusButton.uiObject.rotation.copy(rotation);
        this.plusButton.uiObject.rotation.copy(rotation);
        // attachTransformControls(this.minusButton.uiObject);
        // attachTransformControls(this.plusButton.uiObject);
        this.minusButton.on('click', () => this.onNumericValueChanged(knobName, -5));
        this.plusButton.on('click', () => this.onNumericValueChanged(knobName, 5));
        if (Viewer.zSpaceControls && Viewer.controls.zController) {
            Viewer.zSpaceControls.off('buttonRightDown');
            Viewer.zSpaceControls.on('buttonRightDown', this.onNumericValueMinus = () => {
                this.onNumericValueChanged(knobName, -5);
                const numericValueChangeInterval = setInterval(() => this.onNumericValueChanged(knobName, -5), 400);
                Viewer.zSpaceControls.once('buttonRightUp', () => clearInterval(numericValueChangeInterval));
            });
            Viewer.zSpaceControls.off('buttonLeftDown');
            Viewer.zSpaceControls.on('buttonLeftDown', this.onNumericValuePlus = () => {
                this.onNumericValueChanged(knobName, 5);
                const numericValueChangeInterval = setInterval(() => this.onNumericValueChanged(knobName, 5), 400);
                Viewer.zSpaceControls.once('buttonLeftUp', () => clearInterval(numericValueChangeInterval));
            });
        }
    }
    onModeClick() {
        if (!this.enabledModes.mode)
            return;
        this.currentMode = this.currentMode || 0;
        this.currentMode = (this.currentMode + 1) % 2;
        this.screen.setCurrentMode(this.currentMode);
        this.enabledModes.mode = false;
        this.fire('modeChanged', new ParentEvent('', {
            'newValue': this.currentMode
        }));
    }
    onNumericValueChanged(valueType, changeValue) {
        if (!this.enabledModes[valueType])
            return;
        let _valueType = valueType;
        if (valueType === 'zeroAdjustKnob')
            _valueType = 'transmittance';
        this.numericValues[_valueType] += changeValue;
        switch (_valueType) {
            case 'transmittance':
                this.screen.setTransmittance(this.numericValues[_valueType], valueType);
                break;
            case 'wavelength':
                this.screen.setWaveLength(this.numericValues[_valueType]);
                break;
        }
        this.fire('numericValueChanged', new ParentEvent('', {
            'valueChanged': valueType,
            'newValue': this.numericValues[_valueType]
        }));
    }
    setValues(transmittance, absorbance) {
        this.screen.setAbsorbance(this.numericValues.absorbance = absorbance);
        this.screen.setTransmittance(this.numericValues.transmittance = transmittance);
    }
    generatePlaceholderObject(object) {
        const newObject = deepClone(object);
        newObject.traverse(obj => {
            if (obj instanceof Mesh) {
                obj.material = new MeshBasicMaterial({ wireframe: true, color: 'green' });
            }
        });
        return newObject;
    }
    getTestTubePlaceholder(dragndropGroup) {
        const testTubePlaceholderObject = this.addObject(new Object3D());
        testTubePlaceholderObject.position.set(-1.290731542942966, 0.16473752187878782, -1.404883902557199).add(new Vector3(0.8379232135803458, -0.9010697739942375, 2.076430128288085));
        const testTubePlaceholder = this.addObject(this.generatePlaceholderObject(ResourcesManager.getModel('test_tube_red')), null, testTubePlaceholderObject);
        testTubePlaceholder.visible = false;
        dragndropGroup.on('drag_started', () => {
            testTubePlaceholder.visible = testTubePlaceholderObject.children.length <= 1; // Setting fake test visible
        });
        dragndropGroup.on('drag_ended', () => {
            ResourcesManager.getAudioManger().getAudio('put_sound').play();
            testTubePlaceholder.visible = false; // Setting fake test invisible
        });
        return dragndropGroup.addPlaceholder(testTubePlaceholderObject, new Box3(), `placeholderTestTube`);
    }
    enableInteraction(name) {
        this.enabledModes.zeroAdjustKnob = false;
        this.enabledModes.transmittance = false;
        this.enabledModes.mode = false;
        this.enabledModes.wavelength = false;
        if (name) {
            this.enabledModes[name] = true;
        }
    }
    reset() {
        this.enableInteraction();
        this.setValues(this.defaultNumericValues.transmittance, this.defaultNumericValues.absorbance);
        this.screen.setWaveLength(this.numericValues.wavelength = this.defaultNumericValues.wavelength);
        this.screen.setCurrentMode(this.currentMode = this.defaultCurrentMode);
        this.cap.quaternion.setFromEuler(new Euler(0, 0, 0));
        this.plusButton && this.plusButton.off('click');
        this.minusButton && this.minusButton.off('click');
        if (Viewer.zSpaceControls && Viewer.controls.zController)
            Viewer.zSpaceControls.off('buttonRightDown', this.onNumericValueMinus);
        if (Viewer.zSpaceControls && Viewer.controls.zController)
            Viewer.zSpaceControls.off('buttonLeftDown', this.onNumericValuePlus);
        this.minusButton && (this.minusButton.uiObject.visible = false);
        this.plusButton && (this.plusButton.uiObject.visible = false);
    }
}
